import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { MdEmail, MdPerson } from "react-icons/md";
import axiosClient from "../../axios-client";

const ContactForm = () => {
  const [captchaValue, setCaptchaValue] = useState(null);
  const [phone, setPhone] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.email.trim() || !phone.trim() || !formData.message.trim()) {
      alert("Please fill in all required fields.");
      return;
    }

    if (!captchaValue) {
      alert("Please complete the reCAPTCHA.");
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        mobileNumber: phone.trim(),
        message: formData.message.trim(),
      };

      const response = await axiosClient.post("/contactus/details", payload);
      if (response.status === 201 || response.data?.contact) {
        alert("Thank you! Your message has been sent successfully.");
        setFormData({ name: "", email: "", message: "" });
        setPhone("");
        setCaptchaValue(null);
        recaptchaRef.current?.reset();
      } else {
        alert("Failed to send message: " + (response.data?.error || response.data?.message || "Please try again."));
      }
    } catch (err) {
      console.error("Error submitting contact form:", err);
      const errMsg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "An error occurred while sending your message. Please try again later.";
      alert(errMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="px-4 sm:px-6 md:px-8 pt-4 sm:pt-6 md:pt-8 pb-12 sm:pb-16 md:pb-20">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold font-inter text-center md:text-left">
        Need Assistance? We're Just a Message Away
      </h2>
      <div className="w-full bg-blue p-4 sm:p-5 md:p-6 rounded-lg mt-4 sm:mt-5 md:mt-6 font-inter">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mb-4">
            <div className="col-span-1 relative">
              <span className="absolute inset-y-0 left-3 flex items-center md:bottom-1 text-gray-500">
                <MdPerson className="w-4 h-4 sm:w-5 sm:h-5" />
              </span>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
                className="w-full border border-gray-300 p-2 sm:p-3 pl-9 sm:pl-10 rounded-lg focus:ring-black text-sm sm:text-base"
                required
              />
            </div>

            <div className="col-span-1 md:row-span-2 order-last md:order-none">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write your message here"
                className="w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-black text-sm sm:text-base"
                rows="4"
                required
              ></textarea>
            </div>

            <div className="col-span-1 relative">
              <span className="absolute inset-y-0 left-3 flex items-center md:bottom-1 text-gray-500">
                <MdEmail className="w-4 h-4 sm:w-5 sm:h-5" />
              </span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                className="w-full border border-gray-300 p-2 sm:p-3 pl-9 sm:pl-10 rounded-lg focus:ring-black text-sm sm:text-base"
                required
              />
            </div>

            <div className="col-span-1">
              <PhoneInput
                country={"in"}
                value={phone}
                onChange={(phoneVal) => setPhone(phoneVal)}
                containerClass="flex"
                buttonClass="!border-gray-300"
                inputStyle={{
                  width: "100%",
                  paddingLeft: "48px",
                  fontSize: "14px",
                }}
                enableSearch={true}
                specialLabel=""
                inputProps={{
                  required: true,
                  placeholder: "Enter your phone number",
                  className:
                    "w-full border border-gray-300 p-2 sm:p-3 rounded-lg focus:ring-black bg-white text-gray-500 text-sm sm:text-base",
                }}
              />
            </div>

            <div className="col-span-1 mb-4 sm:mb-6 w-full transform scale-90 sm:scale-100 origin-left">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Lf_QbcqAAAAAIPyQ3aC8Lpxz2YuxeLxeqAiPBKw"
                onChange={onCaptchaChange}
                size="normal"
              />
            </div>
          </div>

          <div className="flex items-center justify-center">
            <button
              type="submit"
              disabled={submitting}
              className="bg-login text-white py-2 sm:py-3 px-4 w-full sm:w-[60%] md:w-[40%] rounded-lg font-medium hover:bg-black transition-colors text-sm sm:text-base disabled:opacity-60"
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
